export enum BUTTON_ACTION {
    DEMO = 'demo',
    OPEN = 'open',
    CODE = 'code',
    OPEN_FAQ = 'openFaq',
    CLOSE_FAQ = 'closeFaq',
    START = 'start',
    PAUSE = 'pause',
    UPLOAD = 'upload',
    DOWNLOAD = 'download',
    SETTINGS = 'settings',
    CLOSE_SETTINGS = 'closeSettings',
    ZOOM_IN = 'zoomIn',
    ZOOM_OUT = 'zoomOut',
    BACK = 'back'
}

export enum FADE_STATUS {
    FADING = 'fading',
    FADED = 'faded',
    NONE = null
}
